import SVG, { CustomSVGProps } from '@/src/components/common/SVG/SVG'

export default function SVGCheck(_: CustomSVGProps) {
  return (
    <SVG width="20" height="20" viewBox="0 0 20 20" fill={'none'} {..._}>
      <g clipPath="url(#clip0_3562_1909)">
        <path
          d="M16.875 5.62524L8.125 14.3749L3.75 10.0002"
          stroke="#121212"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3562_1909">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </SVG>
  )
}
